export const SAVE_INTERNAL_GROUPS = 'SAVE_INTERNAL_GROUPS';
export type SAVE_INTERNAL_GROUPS = typeof SAVE_INTERNAL_GROUPS;

export interface SaveInternalGroupsAction {
    type: SAVE_INTERNAL_GROUPS;
}

export function saveInternalGroups(): SaveInternalGroupsAction {
    return {
        type: SAVE_INTERNAL_GROUPS
    };
}
